<template>
  <div>
    <v-row dense>
      <v-col v-for="(item,i) in days" :key="i" class="caption font-weight-bold">
        <div>{{item}}</div>
        <div class="align-self-end">
          <span v-if="hours[i]!=null" class="caption">
            {{hours[i].begin | moment}}
            <br />
            <!-- <v-divider /> -->
            {{hours[i].end | moment}}
          </span>
          <span v-else>
            <v-icon>mdi-close-circle-outline</v-icon>
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: ["openningHours"],
  data() {
    return {
      days: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    };
  },
  filters: {
    moment: function (minutes) {
      return moment().startOf("day").add(minutes, "minutes").format("HH:mm");
    },
  },
  computed: {
    ...mapGetters({
      kine: "getKineById",
      loading: "loading",
      success: "success",
    }),
    hours() {
      let table = [null, null, null, null, null, null, null];
      this.openningHours.forEach((element) => {
        table[element.day] = element;
      });
      return table;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
tr {
  border: none;
}
td {
  border-right: solid 1px #e0e0e0;
  border-left: solid 1px #e0e0e0;
}
th {
  border-right: solid 1px #e0e0e0;
  border-left: solid 1px #e0e0e0;
}
</style>